import { API_ENDPOINTS } from '../endpoints';
import { getAuthHeaders, handleResponse } from '../client';
import type { DashboardProjectProgressGridVO, DashboardReportResultVO, DashboardReportSaveDTO, DashboardReportSaveResultVO, DashboardStatsVO } from '../types';

export const dashboardApi = {
  getStats: async (params?: { brand?: string; status?: string }): Promise<DashboardStatsVO> => {
    const queryParams = new URLSearchParams();
    if (params?.brand) queryParams.append('brand', params.brand);
    if (params?.status) queryParams.append('status', params.status);

    const response = await fetch(`${API_ENDPOINTS.DASHBOARD.STATS}?${queryParams}`, {
      headers: getAuthHeaders(),
    });
    return handleResponse<DashboardStatsVO>(response);
  },
  getProjectProgressList: async (params?: {
    brand?: string;
    status?: string;
    templateId?: number;
  }): Promise<DashboardProjectProgressGridVO> => {
    const queryParams = new URLSearchParams();
    if (params?.brand) queryParams.append('brand', params.brand);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.templateId != null && params.templateId > 0) {
      queryParams.append('templateId', String(params.templateId));
    }

    const response = await fetch(`${API_ENDPOINTS.DASHBOARD.PROJECTS}?${queryParams}`, {
      headers: getAuthHeaders(),
    });
    return handleResponse<DashboardProjectProgressGridVO>(response);
  },
};


export const dashboardReportApi = {
  getReport: async (params: {
    brand?: string;
    templateIds?: string;
    projectStatus?: string;
    milestoneStatus?: string;
    keyword?: string;
  }): Promise<DashboardReportResultVO> => {
    const sp = new URLSearchParams();
    if (params.brand) sp.set('brand', params.brand);
    if (params.templateIds) sp.set('templateIds', params.templateIds);
    if (params.projectStatus) sp.set('projectStatus', params.projectStatus);
    if (params.milestoneStatus) sp.set('milestoneStatus', params.milestoneStatus);
    if (params.keyword) sp.set('keyword', params.keyword);
    const qs = sp.toString();
    const url = API_ENDPOINTS.DASHBOARD.REPORT + (qs ? '?' + qs : '');
    const response = await fetch(url, { headers: getAuthHeaders() });
    return handleResponse<DashboardReportResultVO>(response);
  },

  save: async (data: DashboardReportSaveDTO): Promise<DashboardReportSaveResultVO> => {
    const response = await fetch(API_ENDPOINTS.DASHBOARD.REPORT_SAVE, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleResponse<DashboardReportSaveResultVO>(response);
  },
};
